module.exports = __webpack_public_path__ + "img/bot.e14de75e.svg";